/* Buy-box behaviour for the shared product card (snippets/brand-product-card).

   Lifted out of zen-home.liquid's inline script so the Precise grid gets the
   same behaviour without a second copy.

   The radios carry their own copy in data-* attributes, so this only moves
   strings around. No prices are computed here: Liquid already worked them out
   against the real variant and its selling plan. Removing the selling_plan
   input on "buy once" is what actually changes the order. */
(function () {
  'use strict';

  function wire(form) {
    if (form.__brandCardWired) { return; }
    form.__brandCardWired = true;

    var planInput = form.querySelector('[data-zh-plan-input]');

    /* Real product cards are a <form>: add via AJAX and open the side drawer
       instead of a full-page POST to /cart. */
    if (form.tagName === 'FORM' && window.zpAddToCart) {
      form.addEventListener('submit', function (e) {
        var idInput = form.querySelector('[name="id"]');
        var vid = idInput && idInput.value;
        if (!vid) { return; }
        e.preventDefault();
        var qtyInput = form.querySelector('[name="quantity"]');
        var qty = qtyInput ? (Number(qtyInput.value) || 1) : 1;
        var plan = (planInput && !planInput.disabled && planInput.value) ? planInput.value : null;
        window.zpAddToCart(vid, qty, plan);
      });
    }

    var opts = form.querySelectorAll('[data-zh-opt]');
    if (!opts.length) { return; }

    var planId = planInput ? planInput.value : null;
    var cta = form.querySelector('[data-zh-cta]');
    var perday = form.querySelector('[data-zh-perday]');
    var ship = form.querySelector('[data-zh-ship]');
    var note = form.querySelector('[data-zh-note]');

    Array.prototype.forEach.call(opts, function (opt) {
      var radio = opt.querySelector('input[type="radio"]');
      if (!radio) { return; }
      radio.addEventListener('change', function () {
        Array.prototype.forEach.call(opts, function (o) {
          o.classList.toggle('is-active', o === opt);
        });
        if (cta) { cta.innerHTML = radio.getAttribute('data-cta') || cta.innerHTML; }
        if (perday) { perday.textContent = radio.getAttribute('data-perday') || ''; }
        if (ship) { ship.textContent = radio.getAttribute('data-ship') || ''; }
        if (note) { note.innerHTML = radio.getAttribute('data-note') || ''; }
        if (planInput) {
          /* A one-time order must not carry a selling plan. */
          planInput.disabled = opt.getAttribute('data-zh-opt') === 'once';
          planInput.value = planInput.disabled ? '' : planId;
        }
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.zh-buy'), wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme editor re-renders, and any grid that swaps cards in. */
  document.addEventListener('shopify:section:load', init);
})();
